import React from "react";

/**
 * RichText — renders plain-text CMS fields with light formatting:
 *   • blank line  -> new paragraph
 *   • single return -> line break
 *   • bare URLs (https://… or www.…) -> clickable links (new tab)
 *   • [link text](https://url) -> clickable link with custom text
 * Built from React elements (no dangerouslySetInnerHTML), so anything else
 * is escaped automatically and safely.
 */
const TOKEN_RE = /(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+))/g;

const linkCls = "text-primary font-semibold underline underline-offset-2 hover:text-ink transition-colors";

function renderInline(text, keyPrefix) {
  const out = [];
  let last = 0;
  let i = 0;
  let m;
  TOKEN_RE.lastIndex = 0;
  while ((m = TOKEN_RE.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    if (m[2] !== undefined) {
      out.push(
        <a key={`${keyPrefix}-l${i++}`} href={m[3]} target="_blank" rel="noopener noreferrer" className={linkCls}>
          {m[2]}
        </a>
      );
    } else {
      const url = m[4];
      const href = url.startsWith("http") ? url : `https://${url}`;
      out.push(
        <a key={`${keyPrefix}-l${i++}`} href={href} target="_blank" rel="noopener noreferrer" className={linkCls}>
          {url}
        </a>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export const RichText = ({ text, className = "", as: Tag = "div", ...rest }) => {
  const paras = (text || "")
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (!paras.length) return null;
  return (
    <Tag className={className} {...rest}>
      {paras.map((p, pi) => (
        <p key={pi} className={pi > 0 ? "mt-4" : undefined}>
          {p.split("\n").map((line, li) => (
            <React.Fragment key={li}>
              {li > 0 && <br />}
              {renderInline(line, `${pi}-${li}`)}
            </React.Fragment>
          ))}
        </p>
      ))}
    </Tag>
  );
};

export default RichText;
